import { EcommerceStrategyIcon, HealthFitnessStrategyIcon, TravelTourismStrategyIcon } from '@/svgs'
import React from 'react'

function FiFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Wellness to Performance: Our Health & Fitness Software
               Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of expertise in health and fitness software
               development, we build seamless, scalable, and high-performance
               solutions. Our structured approach enhances user engagement,
               optimizes wellness tracking, and streamlines fitness management.
            </p>

            <HealthFitnessStrategyIcon />
         </div>
      </section>
   )
}

export default FiFromStrategy
